import { render, staticRenderFns } from "./ViewOnePublicList.vue?vue&type=template&id=09542b5e&scoped=true&"
import script from "./ViewOnePublicList.ts?vue&type=script&lang=ts&"
export * from "./ViewOnePublicList.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09542b5e",
  null
  
)

export default component.exports